import React from "react";
import { string } from "prop-types";
import moment from "moment";

import "./headerDateTime.css";
const HeaderDateTime = ({ dt, dtMainFormat, dtSubFormat, className }) => {
  const mdt = moment.utc(dt);

  const subDt = dtSubFormat ? mdt.format(dtSubFormat) : "";
  const mainDt = dtMainFormat ? mdt.format(dtMainFormat): "";
  return (
    <div className={`cp-header-date-time ${className}`} title={dt}>
      {subDt && <div className='sub-dt small'>{subDt}</div>}
      {mainDt && <div className="main-dt">{mainDt}</div>}
    </div>
  );
};

HeaderDateTime.propTypes = {
  dt: string.isRequired,
  dtMainFormat: string.isRequired,
  dtSubFormat: string,
  className: string
};

export default HeaderDateTime;



// WEBPACK FOOTER //
// ./src/views/components/header_date_time/HeaderDateTime.jsx